<template>
    <div>
        <table class="table">
            <tr>
                <th>{{ competitors[0].name }} ({{ competitors[0].qualifier }})</th>
                <th>{{ competitors[1].name }} ({{ competitors[1].qualifier }})</th>
            </tr>
            <tr>
                <td>
                    id: {{ competitors[0].id }}<br>
                    abbreviation: {{ competitors[0].abbreviation }}<br>
                    country: {{ competitors[0].country }}<br>
                    country_code: {{ competitors[0].country_code }}
                </td>
                <td>
                    id: {{ competitors[1].id }}<br>
                    abbreviation: {{ competitors[1].abbreviation }}<br>
                    country: {{ competitors[1].country }}<br>
                    country_code: {{ competitors[1].country_code }}
                </td>
            </tr>
        </table>
    </div>
    
</template>

<script>
export default {
    name: 'SoccerScoresCompetitors',
    props: {
        competitors: ''
    }
}
</script>

